export default __webpack_public_path__ + "static/media/hero-aboutUs.4dcb174a.jpg";